export class AttributeValues {
    id: number = null
    status: number = 1
    isDeleted: boolean = false
    updateCount: number = 0
    createdBy: string = ""
    createDate: Date
    updatedBy: string = ""
    updateDate: Date
    attributeValue: any = null;
    attributeId: number
    tenantId: number = null
}
